
import React from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import { Avatar, AvatarImage, AvatarFallback } from '@/components/ui/avatar';
import { Button } from '@/components/ui/button';
import { Mail } from 'lucide-react';
import SEO from '@/components/SEO';
import { useTranslation } from 'react-i18next';

const About = () => {
  const { t } = useTranslation('about');
  
  return (
    <div className="min-h-screen flex flex-col">
      <SEO 
        title={`${t('title')} - Frikopplad`}
        description={t('description')}
        url="/om"
      />
      <Navbar />
      <main className="flex-grow">
        <div className="container-custom py-12">
          <h1 className="text-3xl md:text-4xl font-bold text-frikopplad-navy mb-8">{t('title')}</h1>
          
          <div className="flex flex-col md:flex-row gap-8 items-start">
            <div className="md:w-1/3 flex flex-col items-center">
              <Avatar className="w-64 h-64 rounded-lg border border-gray-200 mb-4">
                <AvatarImage 
                  src="/lovable-uploads/ecb1ff6f-117e-4f6a-9799-7ac101671aed.png" 
                  alt="Jonatan Tensetti" 
                  className="object-cover"
                />
                <AvatarFallback>JT</AvatarFallback>
              </Avatar>
              <h3 className="text-xl font-medium text-frikopplad-navy">Jonatan Tensetti</h3>
              <p className="text-gray-600 text-center">{t('role')}</p>
            </div>

            <div className="md:w-2/3">
              <p className="text-gray-700 mb-4">
                {t('content.paragraph1')}
              </p>

              <p className="text-gray-700 mb-4">
                {t('content.paragraph2')}
              </p>

              <p className="text-gray-700 mb-4">
                {t('content.paragraph3')}
              </p>

              <p className="text-gray-700 mb-4">
                {t('content.paragraph4')}
              </p>
              
              <div className="mt-6">
                <a href="mailto:JTensetti@protonmail.com">
                  <Button className="bg-frikopplad-navy hover:bg-frikopplad-blue transition-colors">
                    <Mail className="mr-2" /> {t('contact')}
                  </Button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default About;
